<template>
  <div>电商平台订单转换</div>
</template>
<script>
export default {
  name: 'ecom-evgImport-platformOrderTransfer',
}
</script>
